import Header from '../../components/admin/header/Header';
import SearchKeyword from '../../components/admin/common/SearchKeyword';
import Content from '../../components/admin/event/Content';
import React, { useState, useEffect } from 'react';

export default function Event() {
  const [searchParams, setSearchParams] = useState({});

  const handleSearch = (searchData) => {
    console.log('이벤트 검색:', searchData);
    setSearchParams(searchData);
  };

  return (
    <>
      <Header />
      <div className="content-wrapper">
        <div className="titleNav">이벤트/소식</div>

        <div className="">
          <SearchKeyword
            placeholder="제목을 입력하세요"
            searchType="title"
            onSearch={handleSearch}
          />

          <Content searchParams={searchParams} />
        </div>
      </div>
    </>
  );
}
